<!--
 * @Author: qiye@yscredit.com
 * @Date: 2020-05-18 16:18:09
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-06-06 09:26:30
 * @Description: 通知列表
-->
<template>
  <div class="app-container">
    <div class="statistics">
      <div class="statistics-title">
        <b>数据统计</b>
        注：只统计审核通过且发送成功的消息条数
      </div>
      <div class="statistics-list">
        <div
          class="statistics-list-li"
          v-for="(item, index) in navList"
          :key="index"
        >
          <span>{{ item.name }}</span>
          <b>{{ item.num }}</b>
        </div>
      </div>
    </div>
    <div class="header">
      <div class="header-serach">
        <el-form :inline="true" :model="ruleform">
          <el-form-item label="">
            <el-input
              v-model="content"
              placeholder="搜索消息内容"
              @keyup.enter.native="getSearch"
              clearable
              @clear="getSearch"
            >
              <i
                @click="getSearch"
                slot="suffix"
                class="el-input__icon el-icon-search"
              ></i
            ></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-date-picker
              v-model="timeInterval"
              type="daterange"
              range-separator="至"
              start-placeholder="创建开始时间"
              end-placeholder="创建结束时间"
              value-format="yyyy-MM-dd"
              @change="getSearch"
            >
            </el-date-picker>
          </el-form-item>

          <el-form-item label="">
            <el-select
              v-model="ruleform.examine"
              placeholder="审核状态"
              @change="getSearch"
              clearable
            >
              <el-option
                v-for="item in examineList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-select
              v-model="ruleform.isDeploy"
              placeholder="消息主体"
              @change="getSearch"
              clearable
            >
              <el-option
                v-for="item in messageList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-date-picker
              v-model="pushTimeRange"
              type="daterange"
              range-separator="至"
              start-placeholder="发送开始时间"
              end-placeholder="发送结束时间"
              value-format="yyyy-MM-dd"
              @change="getSearch"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="">
            <el-date-picker
              v-model="scheduledPushRange"
              type="daterange"
              range-separator="至"
              start-placeholder="定时发送时间起"
              end-placeholder="定时发送时间止"
              value-format="yyyy-MM-dd"
              @change="getSearch"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="">
            <el-select
              v-model="ruleform.pushStatus"
              placeholder="推送状态"
              @change="getSearch"
              clearable
            >
              <el-option
                v-for="item in pushStatusList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-button type="primary" @click="newDialogVisible = true"
              >+新建消息</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
    <el-table
      :data="tableData"
      style="width: 100%"
      :header-cell-style="{ background: '#fafafa' }"
      height="500"
    >
      <el-table-column
        prop="content"
        label="消息内容"
        width="250"
        align="center"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column prop="smsSubject" label="消息主体" align="center">
        <template slot-scope="scope">
          <div>
            {{
              scope.row.smsSubject === 1
                ? '企业'
                : scope.row.smsSubject === 2
                ? '专员'
                : '-'
            }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="createBy"
        label="发送人"
        align="center"
      ></el-table-column>
      <el-table-column prop="smsType" label="推送渠道" align="center">
        <template slot-scope="scope">
          <div>{{ smsTypes(scope.row.smsTypes) }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="checkStatus" label="审核状态" align="center">
        <template slot-scope="scope">
          <div>{{ scope.row.checkStatus | statusFilter }}</div>
        </template></el-table-column
      >
      <el-table-column
        prop="createTime"
        label="创建时间"
        align="center"
      ></el-table-column>
      <el-table-column label="定时推送时间" align="center">
        <template slot-scope="scope">
          <div>{{ scope.row.scheduledPushTime || '-' }}</div>
        </template>
      </el-table-column>
      <el-table-column label="推送状态" align="center"
        ><template slot-scope="scope">
          <div>
            {{
              scope.row.pushStatus
                ? pushStatusList[scope.row.pushStatus].label
                : '-'
            }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="推送时间" align="center">
        <template slot-scope="scope">
          <div>{{ scope.row.pushTime || '-' }}</div>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <span
            style="color: #1890ff; cursor: pointer"
            @click="seeDetails(scope.row)"
            >查看</span
          >
          <span
            v-if="scope.row.pushStatus == 1"
            style="color: #1890ff; cursor: pointer; margin-left: 10px"
            @click="pushDialog(scope.row)"
            >推送</span
          >
          <span
            v-if="scope.row.checkStatus == 0"
            style="color: #1890ff; cursor: pointer; margin-left: 10px"
            @click="selectEnt(scope.row)"
            >选择企业</span
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="table-page">
      <el-pagination
        background
        layout="total,prev, pager, next, sizes, jumper"
        :current-page.sync="currentPage"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-size="pageSize"
        :total="totalRecord"
      >
      </el-pagination>
    </div>
    <el-dialog
      title="查看"
      :visible.sync="dialogVisible"
      top="100px"
      width="60%"
    >
      <div class="popup_title">
        <div
          :class="{
            title: detailsTitle.checkStatus === 3,
            title_color: detailsTitle.checkStatus === 2,
            title_colors: detailsTitle.checkStatus === 3
          }"
        >
          {{ detailsTitle.checkStatus | statusFilter }}
        </div>
        <div
          class="ramk"
          v-if="detailsTitle.remark && detailsTitle.checkStatus !== 1"
        >
          备注：{{ detailsTitle.remark || '-' }}
        </div>
        <div class="time" v-if="detailsTitle.checkStatus !== 1">
          审核时间：{{ detailsTitle.checkTime || '-' }}
          <span>审核人：{{ detailsTitle.checkMan || '-' }}</span>
        </div>
      </div>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="其他消息" name="otherMessage"></el-tab-pane>
        <el-tab-pane label="钉钉群消息" name="ddGroupMessage"></el-tab-pane>
      </el-tabs>
      <div class="popup_header" v-if="activeName == 'otherMessage'">
        <span
          v-if="
            detailsTitle.checkStatus === 3 ||
            (detailsTitle.checkStatus === 3 && detailsTitle.smsSubject !== 2)
          "
          >发送状态 :
        </span>
        <el-select
          v-if="
            detailsTitle.checkStatus === 3 ||
            (detailsTitle.checkStatus === 3 && detailsTitle.smsSubject !== 2)
          "
          v-model="sendOut"
          placeholder="请选择发送状态"
          @change="getDetail(channelId)"
          clearable
          :disabled="rewireLoading"
        >
          <el-option
            v-for="item in IndustryList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <span v-if="detailsTitle.smsSubject === 1">推送渠道 : </span>
        <el-select
          v-model="channel"
          placeholder="请选择推送渠道"
          @change="getDetail(channelId)"
          clearable
          v-if="detailsTitle.smsSubject === 1"
          :disabled="rewireLoading"
        >
          <el-option
            v-for="item in channelList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <span
          v-if="detailsTitle.checkStatus === 3 && detailsTitle.smsSubject === 1"
          >是否已读 :
        </span>
        <el-select
          v-if="detailsTitle.checkStatus === 3 && detailsTitle.smsSubject === 1"
          v-model="isReadValue"
          placeholder="是否已读"
          @change="getDetail(channelId)"
          clearable
          :disabled="rewireLoading"
        >
          <el-option
            v-for="item in isRead"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <div class="popup_toals">
        共 <b>{{ totalRecords }}</b> 条数据
      </div>

      <el-table
        v-if="activeName == 'otherMessage'"
        :data="tableChannel"
        style="width: 100%"
        v-loading="rewireLoading"
        :header-cell-style="{ background: '#fafafa' }"
      >
        <el-table-column
          v-if="detailsTitle.smsSubject !== 2"
          label="发送企业"
          width="250"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <div>{{ scope.row.entName }}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="staffName"
          label="接收人"
          align="center"
        ></el-table-column>
        <el-table-column
          v-if="detailsTitle.smsSubject !== 2"
          prop="isRead"
          label="是否已读"
          align="center"
        >
          <template slot-scope="scope">
            <div>
              {{
                scope.row.isRead === 0
                  ? '未读'
                  : scope.row.isRead === 1
                  ? '已读'
                  : '-'
              }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="smsType" label="推送渠道" align="center">
          <template slot-scope="scope">
            <div>
              <!-- {{ scope.row.smsType == '0' ? '手机短信' : '微信公众号' }} -->
              {{ newChannel[scope.row.smsType] }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          v-if="detailsTitle.pushStatus != 1"
          prop="status"
          label="发送状态"
          align="center"
        >
          <template slot-scope="scope">
            <div style="display: inline-block">
              {{
                scope.row.status == null
                  ? '-'
                  : scope.row.status == 0
                  ? '发送失败'
                  : '发送成功'
              }}
            </div>
            <span
              v-if="scope.row.status === 0"
              style="color: #1890ff; cursor: pointer; margin-left: 10px"
              @click="retransmission(scope.row)"
              >重发</span
            >
            <div v-if="scope.row.excessTime" class="count-down">
              等待{{ scope.row.excessTime }}s
            </div>
          </template></el-table-column
        >
      </el-table>
      <el-table
        v-if="activeName == 'ddGroupMessage'"
        :data="ddSmsList"
        style="width: 100%"
        v-loading="rewireLoading"
        :header-cell-style="{ background: '#fafafa' }"
      >
        <el-table-column
          prop="robotName"
          label="钉钉群名称"
          width="250"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <div>{{ scope.row.robotName }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="staffName" label="推送渠道" align="center">
          <template slot-scope="scope">
            <div>{{ newChannel[scope.row.smsType] }}</div>
          </template>
        </el-table-column>
      </el-table>
      <div class="table-page">
        <el-pagination
          background
          layout="total,prev, pager, next, sizes, jumper"
          :current-page.sync="currentPages"
          @size-change="handleSizeChanges"
          @current-change="handleCurrentChanges"
          :page-size="pageSizes"
          :total="totalRecords"
          :disabled="rewireLoading"
        >
        </el-pagination>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 新建消息 -->
    <el-dialog
      title="新建消息"
      :visible.sync="newDialogVisible"
      top="150px"
      width="45%"
    >
      <div class="new_title">请选择推送的消息主题</div>
      <div class="new_conetnt">
        <div class="content_left" @click="addNews(0)">
          <b>给企业发消息</b>
          <span>支持微信公众号、手机短信、浙里办、站内信</span>
        </div>
        <div class="content_right" @click="addNews(1)">
          <b>给专员发消息</b>
          <span>支持浙政钉</span>
        </div>
      </div>
      <!-- <span slot="footer" class="dialog-footer">
        <el-button @click="newDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="addNews">确 定</el-button>
      </span> -->
    </el-dialog>
    <!-- 推送 -->
    <el-dialog
      title="推送"
      :visible.sync="pushDialogVisible"
      top="250px"
      width="25%"
      class="push-visible"
    >
      <div class="timing">
        <el-radio-group v-model="pushWay" @change="pushNow">
          <el-radio :label="1">立即推送</el-radio>
          <el-radio style="margin-left: 100px" :label="2">定时推送</el-radio>
        </el-radio-group>
      </div>
      <div v-if="pushWay == 2">
        <span>定时推送时间：</span>
        <el-date-picker
          v-model="pushTime"
          type="datetime"
          placeholder="选择日期时间"
          format="yyyy-MM-dd HH:mm"
          value-format="yyyy-MM-dd HH:mm"
          :picker-options="option"
          @change="handle"
        >
        </el-date-picker>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="pushDialogVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click="pushMessage()"
          :loading="pushLoading"
          >{{ pushLoading ? '推送中' : '确 定' }}</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  listSmsRecord,
  getSmsContent,
  querySmsRecord,
  newsStatistics
} from '@api/video/video'
import {
  pushSmsContent,
  getMapProcess,
  resendSmsRecord,
  getDingTalkRecordByPage
} from '@api/corporateInteraction/examine'
export default {
  data() {
    return {
      open: false,
      content: '', // 视频名称
      options: [
        { value: '全部', label: '全部' },
        { value: '直播回放', label: '直播回放' },
        { value: '法律类', label: '法律类' },
        { value: '政策解读', label: '政策解读' },
        { value: '人力资源', label: '人力资源' },
        { value: '企业管理', label: '企业管理' },
        { value: '其他', label: '其他' }
      ], // 所有类别数据
      detailsTitle: {
        checkStatus: '',
        remark: '',
        checkTime: '',
        checkMan: '',
        smsSubject: ''
      },
      tableData: [],
      tableChannel: [],
      ddSmsList: [],
      IndustryList: [
        { value: '', label: '全部' },
        { value: 1, label: '发送成功' },
        { value: 0, label: '发送失败' }
      ],
      channelList: [
        { value: '', label: '全部' },
        { value: 0, label: '手机短信' },
        { value: 1, label: '微信公众号' },
        { value: 2, label: '站内消息' },
        { value: 4, label: '浙里办消息' }
      ],
      isRead: [
        { value: '', label: '全部' },
        { value: 1, label: '已读' },
        { value: 0, label: '未读' }
      ],
      ruleform: {
        examine: '', // 审核
        message: '', // 发布
        startTime: '', // 开始时间
        endTime: ''
      },
      timeInterval: '',
      examineList: [
        { value: '', label: '全部' },
        { value: 0, label: '待提交' },
        { value: 1, label: '待审核' },
        { value: 3, label: '审核通过' },
        { value: 2, label: '审核驳回' }
      ],
      messageList: [
        { value: '', label: '全部' },
        { value: 1, label: '企业' },
        { value: 2, label: '专员' }
      ],
      pushStatusList: [
        { value: '', label: '全部' },
        { value: 1, label: '待推送' },
        { value: 2, label: '推送失败' },
        { value: 3, label: '部分推送成功' },
        { value: 4, label: '推送成功' }
      ],
      navList: [
        {
          name: '消息累计推送数量（条）：',
          num: 0,
          value: 'totalSmsNum'
        },
        {
          name: '微信公众号累计数量（条）：',
          num: 0,
          value: 'weChatNum'
        },
        {
          name: '手机短信累计数量（条）：',
          num: 0,
          value: 'smsNum'
        },
        {
          name: '浙里办累计数量（条）：',
          num: 0,
          value: 'zlbSmsNum'
        },
        {
          name: '浙政钉累计数量（条）：',
          num: 0,
          value: 'dtalkSmsNum'
        },
        {
          name: '站内消息累计数量（条）：',
          num: 0,
          value: 'innerSmsNum'
        }
      ],
      sendOut: '',
      channel: '',
      isReadValue: '',
      channelId: '',
      pageSize: 10,
      currentPage: 1,
      totalRecord: 0,
      pageSizes: 10,
      currentPages: 1,
      totalRecords: 0,
      repeat: false,
      dialogVisible: false,
      dialogVisibles: false,
      newDialogVisible: false,
      pushDialogVisible: false,
      msgContent: {},
      newChannel: {
        0: '手机短信',
        1: '微信公众号',
        2: '站内消息',
        3: '浙政钉消息',
        4: '浙里办消息',
        5: '钉钉群消息'
      },
      pushWay: '',
      pushTime: '',
      option: {
        disabledDate: (time) => {
          return time.getTime() < Date.now() - 1 * 24 * 3600 * 1000
        }
      },
      pushTimeRange: '',
      scheduledPushRange: '',
      activeName: 'otherMessage',
      smsTypeStr: '0,1,2,4', // 区分钉钉群消息和其他消息
      timer: null,
      pushId: '',
      pushLoading: false,
      resetSmsTimer: null,
      rewireLoading: false
    }
  },
  watch: {},
  computed: {
    smsTypes() {
      return (name) => {
        const a = []
        name.map((item) => {
          a.push(this.newChannel[item])
        })
        return a.join('，')
      }
    }
  },
  filters: {
    statusFilter(val) {
      let value = ''
      switch (Number(val)) {
        case 0:
          value = '待提交'
          break
        case 1:
          value = '待审核'
          break
        case 2:
          value = '审核驳回'
          break
        case 3:
          value = '审核通过'
          break

        default:
          break
      }
      return value
    },
    daojishi(mistiming) {
      return mistiming
    }
  },
  mounted() {
    this.listSmsRecord()
    this.statistics()
  },
  created() {},
  methods: {
    selectEnt(row) {
      this.$router.push({
        name: 'smsSelectEnt',
        query: {
          id: row.id
        }
      })
    },
    // 推送
    pushDialog(row) {
      this.pushId = row.id
      this.pushWay = row.pushWay // 推送方式
      this.pushTime = row.scheduledPushTime // 推送时间
      this.pushDialogVisible = true
    },
    pushNow(e) {
      this.pushTime = ''
    },
    handle() {
      var startAt = (new Date(this.pushTime) * 1000) / 1000
      var date = new Date()
      var min = date.getMinutes() // 2. 获取当前分钟
      if (startAt < date.setMinutes(min + 5)) {
        this.$message({
          message: '选择的时间必须大于当前时间5分钟后',
          type: 'warning'
        })
        this.pushTime = ''
      }
    },
    // 查看详情
    seeDetails(row) {
      this.pageSizes = 10
      this.currentPages = 1
      this.activeName = 'otherMessage'
      const {
        checkStatus,
        remark,
        checkTime,
        checkMan,
        smsSubject,
        pushStatus
      } = row
      this.detailsTitle = {
        checkStatus,
        remark,
        checkTime,
        checkMan,
        smsSubject,
        pushStatus
      }
      this.channelId = row.id
      this.getDetail(row.id)
    }, // 视频名称
    getSearch() {
      this.currentPage = 1
      this.listSmsRecord()
    },
    addNews(e) {
      if (e === 0) {
        this.$router.push({ name: 'addMessage' })
      } else {
        this.$router.push({ name: 'commissionerNews' })
      }
    },
    // 所有类别
    getPoss() {
      this.currentPage = 1
      this.listSmsRecord()
    },
    //  表格翻页
    handleCurrentChange(currentPage, e) {
      this.currentPage = currentPage
      this.listSmsRecord()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.listSmsRecord()
    },
    // popup-list
    //  表格翻页
    handleCurrentChanges(currentPage, e) {
      this.currentPages = currentPage
      if (this.activeName == 'otherMessage') {
        this.getDetail(this.channelId)
      } else {
        this.getDDSmsDetail()
      }
    },
    handleSizeChanges(val) {
      this.pageSizes = val
      if (this.activeName == 'otherMessage') {
        this.getDetail(this.channelId)
      } else {
        this.getDDSmsDetail()
      }
    },
    // 列表
    listSmsRecord() {
      let par = {
        pageSize: this.pageSize,
        pageNum: this.currentPage,
        content: this.content,
        endTime: this.timeInterval
          ? this.timeInterval[1] + ' ' + '23:59:59'
          : '',
        startTime: this.timeInterval
          ? this.timeInterval[0] + ' ' + '00:00:00'
          : '',
        checkStatus: this.ruleform.examine,
        smsSubject: this.ruleform.isDeploy,
        pushStatus: this.ruleform.pushStatus,
        scheduledPushStartTime: this.scheduledPushRange
          ? this.scheduledPushRange[0] + ' ' + '00:00:00'
          : '',
        scheduledPushEndTime: this.scheduledPushRange
          ? this.scheduledPushRange[1] + ' ' + '23:59:59'
          : '',
        pushStartTime: this.pushTimeRange
          ? this.pushTimeRange[0] + ' ' + '00:00:00' + ''
          : '',
        pushEndTime: this.pushTimeRange
          ? this.pushTimeRange[1] + ' ' + '23:59:59'
          : ''
      }
      listSmsRecord(par).then((res) => {
        if (res.data.code == '0000') {
          let data = res.data.data
          this.tableData = data.list || []
          this.totalRecord = data.total || 0
        }
      })
    },
    // 查看
    getDetail(id) {
      this.channelId = id
      let par = {
        pageSize: this.pageSizes,
        pageNum: this.currentPages,
        status: this.sendOut,
        isRead: this.isReadValue,
        smsContentId: this.channelId,
        smsType: this.channel,
        smsTypeStr: this.smsTypeStr
      }

      querySmsRecord(par).then((res) => {
        if (res.data.code == '0000') {
          let data = res.data.data
          // // 给每一列生成一个时间戳
          // list.results.forEach(el => {
          //   el.excessTime = 60 // 模拟后端发的时间戳
          //   this.daojishi(el) // 调用定时器
          // })
          this.tableChannel = data.list || []
          this.totalRecords = data.total || 0
          this.dialogVisible = true
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    // 重发
    retransmission(row) {
      resendSmsRecord({
        smsReadRecordId: row.id
      }).then((res) => {
        if (res.data.code == '0000') {
          setTimeout(() => {
            this.rewireLoading = true
            this.getResetMapProcess(res.data.data)
            this.resetSmsTimer = setInterval(
              this.getResetMapProcess,
              3000,
              res.data.data
            )
          })
        }
      })
      return
      const indexs = this.tableChannel[row.$index]
      indexs.excessTime = 60
      this.daojishi(indexs, row.$index)
    },

    getResetMapProcess(key) {
      getMapProcess({ key }).then((res) => {
        const { data, code, msg } = res.data
        const process = Number(data.process)
        if (process == 1) {
          this.rewireLoading = false
          clearInterval(this.resetSmsTimer)
          this.getDetail(this.channelId)
          this.$message.success('重发成功')
        }
      })
    },
    // 倒计时定时器
    daojishi(row, index) {
      console.log(row)

      setTimeout(() => {
        row.countDown = setInterval(() => {
          if (row.excessTime > 0) {
            row.excessTime = row.excessTime - 1
          } else {
            clearInterval(row.countDown)
          }
          this.$set(this.tableChannel, index, row)
        }, 1000)
      }, 1000)
    },
    // 数据统计
    statistics() {
      newsStatistics().then((res) => {
        const data = res.data.data
        this.navList.map((val, index) => {
          Object.keys(data).find((f) => {
            if (val.value === f) {
              val.num = data[f]
            }
          })
        })
      })
    },
    // 其他消息和钉钉群消息切换
    handleClick() {
      this.pageSizes = 10
      this.currentPages = 1
      if (this.activeName == 'ddGroupMessage') {
        this.getDDSmsDetail()
      } else {
        this.getDetail(this.channelId)
      }
    },
    getDDSmsDetail() {
      getDingTalkRecordByPage({ smsContentId: this.channelId }).then((res) => {
        if (res.data.code == '0000') {
          this.ddSmsList = res.data.data.results
          this.totalRecords = res.data.data.totalRecord
        }
      })
    },
    // 列表推送
    pushMessage() {
      if (!this.pushWay) {
        return this.$message.warning('请选择推送类型')
      } else {
        if (this.pushWay == 2 && !this.pushTime) {
          return this.$message.warning('请选择推送时间')
        }
      }
      const params = {
        id: this.pushId,
        pushWay: this.pushWay,
        scheduledPushTime: this.pushTime
      }
      pushSmsContent(params).then((res) => {
        const data = res.data
        if (data.code == '0000') {
          if (this.pushWay == 1) {
            setTimeout(() => {
              this.pushLoading = true
              this.getMapProcess(data.data)
              this.timer = setInterval(this.getMapProcess, 3000, data.data)
            })
          } else {
            this.listSmsRecord()
            this.pushDialogVisible = false
            this.$message.success(data.msg)
          }
        } else {
          this.$message.error(data.data)
        }
      })
    },
    getMapProcess(key) {
      getMapProcess({ key }).then((res) => {
        const { data, code, msg } = res.data
        const process = Number(data.process)
        if (process == 1) {
          clearInterval(this.timer)
          this.pushLoading = false
          this.listSmsRecord()
          this.pushDialogVisible = false
          this.$message.success('推送成功')
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-dialog__wrapper {
  .el-dialog__header {
    border-bottom: 1px solid #e6e6e6;
  }
  .el-dialog__body {
    height: 590px;
    overflow-y: auto;
    font-size: 16px;
    position: relative;
    padding: 15px 20px 30px;
    .popup_title {
      margin-bottom: 20px;
      font-size: 15px;
      border-bottom: 1px solid #e6e6e6;
      > div {
        margin-bottom: 10px;
      }
      .title {
        color: #66cc00;
      }
      .title_color {
        color: #f00;
      }
      .title_colors {
        color: rgb(8, 8, 8);
      }
      span {
        margin-left: 60px;
      }
    }
    .popup_toals {
      font-size: 14px;
      text-align: right;
      margin: 0 10px 10px;
      b {
        font-size: 15px;
        color: #0099ff;
      }
    }
    .popup_header {
      span {
        margin-left: 30px;
      }
    }
    .table-page {
      width: 50%;
      margin: 30px auto;
    }
    & > div {
      & > div {
        margin-bottom: 20px;
        .texthide {
          width: auto;
          overflow: hidden; //超出的文本隐藏
          text-overflow: ellipsis; //溢出用省略号显示
          white-space: nowrap;
        }
        .textshow {
          span {
            width: auto;
          }
        }
        &:nth-child(1) {
          display: flex;
          > span {
            display: inline-block;
          }
          span {
            font-size: 14px;
            // color: #1890ff;
          }
        }
      }
    }
    .new_title {
      color: rgba(102, 102, 102, 100);
      font-size: 16px;
      margin: 24px 28px;
    }
    .new_conetnt {
      display: flex;
      justify-content: space-around;
      > div {
        width: 300px;
        height: 150px;
        margin-top: 50px;
        border-radius: 12px;
        background-color: rgba(255, 255, 255, 1);
        box-shadow: 0px 3px 8px 0px rgba(0, 0, 0, 0.16);
        position: relative;
        cursor: pointer;
      }
      > div:hover {
        border: 1px solid #1890ff;
      }
      > div::after {
        content: '';
        width: 120px;
        height: 160px;
        background: url('../../../../assets/imagess/book.png') no-repeat right
          20px;
        background-size: 100%;
        position: absolute;
        right: -20px;
        top: -35px;
      }
      b {
        color: rgba(24, 144, 255, 100);
        font-size: 18px;
        margin: 30px 20px;
        display: block !important;
      }
      span {
        display: block !important;
        color: rgba(0, 0, 0, 0.85) !important;
        font-size: 14px;
        width: 140px;
        line-height: 20px;
        margin-left: 20px;
      }
      .content_left {
        display: block;
      }
      .content_right::after {
        height: 300px;
        background: url('../../../../assets/imagess/man.png') no-repeat;
        background-size: 100%;
      }
    }
  }

  .el-dialog__footer {
    border-top: 1px solid rgba(0, 0, 0, 0.3);
  }
}
.push-visible {
  font-size: 16px;
  /deep/.el-dialog__body {
    height: 250px !important;
    padding-left: 20px;
    text-align: center;
    .timing {
      margin: 20px 55px 30px;
      text-align: center;
    }
  }
}
.statistics {
  width: 100%;
  padding: 20px 20px 0;
  font-size: 14px;
  color: #999999;
  background-color: #f6f7f9;
  border-radius: 4px;
  margin-bottom: 20px;
  &-title {
    b {
      font-size: 18px;
      color: #000;
      margin-right: 10px;
    }
  }
  &-list {
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    &-li {
      width: 30%;
      margin-bottom: 20px;
      b {
        color: #0099fe;
      }
    }
  }
}
.header {
  display: flex;
  margin-bottom: 10px;
  .header-serach {
    width: 95%;
    .el-input {
      width: 300px;
      margin-right: 50px;
    }
  }
  .addPru {
    width: 100px;
    display: inline-block;
    text-align: center;
    position: absolute;
    right: 50px;
    height: 36px;
    border-radius: 5px;
    line-height: 36px;
    background: #1890ff;
    color: #fff;
    cursor: pointer;
  }
}
.changeAppeal {
  cursor: pointer;
  color: #1890ff;
}
.el-table::before {
  height: 0px;
}
.table-page {
  width: 100%;
  text-align: center;
  margin-top: 24px;
  margin-bottom: 20px;
}
.count-down {
  font-size: 12px;
  color: #bababa;
}
/deep/.el-range-separator {
  width: 30px;
}
/deep/.el-tabs__nav-wrap {
  width: 100%;
}
</style>
<style lang="scss">
.el-tooltip__popper {
  max-width: 300px;
}
</style>
